import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { FileDownloadService } from "../services/FileDownload-Service";
import { Router, NavigationExtras } from "@angular/router";
import { SohoModalDialogService, SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { AuthHelper } from './../services/authHelper';
import { UserData } from '../shared/models/user.model';
import { EventEmitter } from 'stream';
import { EventHandlerVars } from '@angular/compiler/src/compiler_util/expression_converter';
import { ResponseMsg } from '../common/response-message';

@Component({
  selector: 'app-archivefile-list',
  templateUrl: './archivefile-list.component.html',
  styleUrls: ['./archivefile-list.component.css']
})
export class ArchivefileListComponent implements OnInit {
    @ViewChild(SohoDataGridComponent) datagrid!: SohoDataGridComponent;
    @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
    showBusy = true;
    Message = "Loading...";
    public data!: any[];
    public grid_Columns!:SohoDataGridColumn[];
    public GrdRequests: any;
    public filteredRequests: any;
    public filteredArray: any[] = [];
    public filteredIds: any[] = [];
    public filteredRequestTypaArray: any[] = [];
    public filteredRequestTypeIds: any[] = [];
    public filteredCreatedBy: any[] = [];
    emailAddress!: string;
    description!:string;
    userData = new UserData();
  
    constructor(private capacityModelService: CapacityModelService, private fileDownloadService:FileDownloadService,
      private router: Router,
      private modalService: SohoModalDialogService,
      private authhelper: AuthHelper,
      private ngZone: NgZone) { }
  
    ngOnInit(): void {
      this.userData = JSON.parse(localStorage.getItem("userprofile")!);
      if (this.userData == null || this.userData == undefined ||  this.userData.Email == "" || this.userData.SecurityroleDescription == "") {
        this.authhelper.setUserRoleAndLoginDetails();
      }
      this.emailAddress = this.userData.Email;
      this.GetArchiveFilesDetails();

        $('#QuotaApprovedatagrid').datagrid({
          editable: true,
          paging: true,
          //selectable: 'multiple',
          //toolbar: {title: 'Data Grid Header Title', results: true, personalize: true, actions: true, rowHeight: true, keywordFilter: true,  collapsibleFilter: true},
          
          //pagesize: 5,
          //pagesizes: [2, 5, 6],
          //columnReorder: true,
          //showDirty: true
          }).on('cellchange', (e, args) => {
            debugger;
          this.fileStatus(args);
        });

    }
    GetArchiveFilesDetails() {
      this.data = [];
      this.grid_Columns = [];
      this.start();
        this.capacityModelService.GetArchiveFiles(this.userData.Email).subscribe(
        detailedquotas => {
            this.data = detailedquotas;
            this.grid_Columns = this.gridColumns;
             if (this.data != null) {   
            this.GrdRequests = $("#QuotaApprovedatagrid").datagrid().data();
            this.GrdRequests.datagrid.renderRows();
            this.stop();
          }
        },
        (error: Response) => {
          this.stop();
          console.log(error);
        }
      );
  
    }
    start() {
      (this.busyIndicator as any).activated = true;
    }
    stop() {
      (this.busyIndicator as any).activated = false;
    }
    ShowAlert(Title: any, Message: any) {
      const dialogRef1 = this.modalService
        .message("<h2>" + Message + "</h2>")
        .buttons([
          {
            text: "Ok",
            click: () => {
              dialogRef1.close("Ok");
  
            },
            isDefault: true
          }
        ])
        .title(Title)
        .open()
        .frameHeight(1000);
    }
    DownloadFiles() {
      this.start();
      this.InitiatePlanDownload();
    }
      InitiatePlanDownload() {
  
      let selectedid: any[] = [];
      let filterid!: any;
      this.filteredArray = [];
      this.filteredRequestTypaArray=[];
      var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
      //console.log(selectedRowsCount);
      if (selectedRowsCount <= 0) {
        this.filteredArray = [];
        this.filteredRequestTypaArray=[];
      }
      else {
        for (var i = 0; i < selectedRowsCount; i++) {
          debugger
          this.filteredRequests = false;
          if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
            this.filteredRequests = true
          }
          else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
            this.filteredRequests = true
          }
          if (this.filteredRequests) {
            debugger
            this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.requestid;
            this.filteredRequestTypeIds = this.GrdRequests.datagrid.selectedRows()[i].data.requesttypeid;
            this.filteredArray.push(this.filteredIds);
            this.filteredRequestTypaArray.push(this.filteredRequestTypeIds);
          }
  
        }
      }
      if (this.filteredArray.length > 0) {
        this.start();
        for (var i = 0; i < this.filteredArray.length; i++) {
          filterid = <JSON><unknown>{ "requestid": this.filteredArray[i], "requesttypeid" : this.filteredRequestTypaArray[i], "userlogin": this.emailAddress == null ? "" : this.emailAddress,"archived":true };
          selectedid.push(filterid);
        }
        
        this.capacityModelService.GetPreSignedUrls(selectedid).subscribe(
          response => {
            this.fileDownloadService.DownloadFromPresignURL(response);
            this.ShowAlert("Alert", "Files Downloaded successfully.");
            if (this.data != null) {   
              this.GrdRequests = $("#QuotaApprovedatagrid").datagrid().data();
              this.GrdRequests.datagrid.renderRows();
            }
            this.stop();
          },
          (err: Response) => {
            console.log(err);
            this.stop();
            this.ShowAlert("Alert", err);
            this.ShowAlert("Alert", "Error while downloading.");
          }
        );
      }
      else {
        this.stop();
        this.ShowAlert("Information", "Please select atleast one to download.");
      }
    }
    gridColumns = [
      {
        id: 'selectionCheckbox',
        sortable: false,
        resizable: false,
        editable: false,
        formatter: Soho.Formatters.SelectionCheckbox,
        align: 'center'
      },
      {
        id: "uniqueid",
        name: "Unique ID",
        field: "uniqueid",
        hidden: true,
        formatter: Soho.Formatters.Text
      },
      {
        id: "requestid",
        name: "Request ID",
        sortable: true,
        field: "requestid",
        filterType: 'text',
        editable: false,
        formatter: Soho.Formatters.Text,
      },
      {
        id: "requesttype",
        name: "Request Type",
        sortable: true,
        field: "requesttype",
        filterType: 'text',
        editable: false,
        formatter: Soho.Formatters.Text,
      },
      {
        id: 'updated',
        name: 'Archived On',
        field: 'updated',
        filterType: 'date',
        editable: false,
        formatter: Soho.Formatters.Date,
        dateFormat: 'M/d/yyyy hh:mm:ss',
        width : 180
      },
      {
        id: "updatedby",
        name: "Archived By",
        field: "updatedby",
        filterType: 'text',
        editable: false,
        formatter: Soho.Formatters.Text,
        width : 250
        
      },

     { 
      id: "description",
      name: "Description",
      field: "description",
      editor: Soho.Editors.Input,
      sortable: true,
      resizable: true,
      reorderable: true,
      editable: true,
      formatter: Soho.Formatters.Text,
    },
    {
        id: 'download',
        name: 'Download',
        field: 'downloadfile',
        icon: 'download',
        editable: false,
        formatter: Soho.Formatters.Button,
        click: (e, args) => this.downloadFile(args),
    }
    ];

    
    downloadFile(args) {
      this.start();
      let selecteddonwloadid: any[] = [];
      let downlaodid!: any;
      downlaodid = <JSON><unknown>{ "requestid": args["0"].item.requestid, "requesttypeid" : args["0"].item.requesttypeid, "userlogin": this.emailAddress == null ? "" : this.emailAddress,"archived":true};
      selecteddonwloadid.push(downlaodid);
      if(selecteddonwloadid.length >0){
        this.capacityModelService.GetPreSignedUrls(selecteddonwloadid).subscribe(
          response => {
            this.fileDownloadService.SingleDownloadFromPresignURL(response["0"].PresignedURL);
            this.stop()
          },
          (err: Response) => {
            console.log(err);
            this.stop();
          }
        );
      }
    }
   
    fileStatus(args) {
      let uploadeddata!: any;
      uploadeddata = <JSON><unknown>{ "requestid": args.rowData.requestid,"description":args.rowData.description};
      if(uploadeddata != null){
        debugger
        if(uploadeddata.description.length < 1000){
          this.description;
          debugger;
          this.capacityModelService.ArchivedFileComments(uploadeddata).subscribe(
            response => {
              if (response.Status == 200) {
                this.ShowAlert("Confirmation","Comment updated successfully.");
              } else {
                this.ShowAlert("Error occured", ResponseMsg.ErrorMsg);
              }
        });
      }
      else{
        this.ShowAlert("Error occured.","Comment is too long");
        this.GetArchiveFilesDetails();
      } 
    }
  }
    
}
      